<template>
    <div class="papsi-container w-[100%] ">
        <div class="flex flex-row h-[80vh] rounded-md  border-[#026b00c7] border-[3px]">
            <div class="border-[#026b004d] border-r w-[460px]   bg-[#e4e3e3] rounded-s">
                <div class=" h-[11.1%] border-b border-[#c4c4c4] px-5 flex items-center w-full">
                    <div class="flex w-full justify-between items-center ">
                        <h1 class="text-[#016B00] text-xl font-semibold ">Message</h1>
                        <AddMessage @click="modalMessage = true"/>
                    </div>
                </div>
            <div class="h-[88.9%] relative">
                <div v-for="(inbox,index) in inbox" :key="index" class="flex items-center  gap-4 hover:bg-[#dadada] py-2 px-5 rounded-md" @click="getMessage(inbox)">
                    <div class="">
                        <img class="w-[50px]" src="../../assets/user.png">
                    </div>
                    <div class="">
                        <p v-if="inbox.from != $store.state.employee_key" class="text-[#6b6b6b] text-xs font-semibold">{{ getName(inbox.from)}}</p>
                        <p v-else class="text-[#6b6b6b] text-xs font-semibold">{{ getName(inbox.to)}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="border-[#c4c4c4] border w-full ">
            <div class="flex w-full border-[#026b004d] border-b h-[11%] items-center px-5 gap-5">
                <img class="w-[55px]" src="../../assets/user.png">
                <div class="">
                    <p class="font-bold text-[#12760A] text-lg">{{ DisplayName }}</p>
                    <!-- <p class="text-[#5c5c5c]">SOFTWARE DEVELOPER</p> -->
                </div>
            </div>
            <div class="h-[79%]  flex flex-col gap-2 justify-end py-5 relative ">
                <div v-if="messageLoading" class="absolute  w-full h-full flex justify-center items-center z-0 px-5" >
                    <span class="loader z-50"></span>
                </div>
                      <div class="overflow-auto px-5 " id="messageContainer">
                            <div  v-for="(message,index) in message" :key="index" class="flex">
                                <div v-if="message.from === $store.state.employee_key" class="flex w-full justify-end ">
                                    <div class="flex-col w-[50%]">
                                        <div class="flex justify-end py-1 ">
                                            <p class="bg-[#12760A] py-2 px-4 rounded-xl break-all text-white ">
                                                {{ message.message }}
                                            </p>
                                        </div>
                                        <p class="text-xs rounded-full text-[#918d8d] flex justify-end ">
                                            {{ message.date + " " + message.time }}
                                        </p>
                                    </div>
                                </div>
                                <div v-else class="flex justify-start w-full">
                                    <div class="flex-col w-[50%]">
                                        <div class="flex justify-start py-1">
                                            <p class="bg-[#959695] py-2 px-4 rounded-xl break-all text-white">
                                                {{ message.message }}
                                            </p>
                                        </div>
                                        <p class="text-xs rounded-full text-[#918d8d] justify-start whitespace-nowrap">
                                            {{ message.date + " " + message.time }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
            </div>
            <div class="flex items-center px-5 border-[#026b004d] border-t h-[10%] gap-5 ">
                <div class="w-[90%]">
                    <input type="text" placeholder="Send Message" class="border-[#cacaca] w-full border px-5 py-3 rounded-md outline-none" v-model="messageData">
                </div>
                <div class="w-[10%]">
                    <button class="w-full bg-[#016B00] py-3 rounded-md text-white" @click="sendMessage" >Send</button>
                </div>
            </div>
        </div>
        
    </div>
</div>
<div>
</div>
<div v-if="modalMessage">
    <MessageModal @cancel="modalMessage = false" @sendMessage="createMessage"/>
</div>
<div v-if="PromptEnabled">
    <Prompt @CloseSignatory="PromptEnabled=false" :type="PromptType"/>
</div>

</template>

<script>
import Services from "../../services/admin"
import MessageModal from ".././controls/modal/MessageModal.vue"
import AddMessage from ".././icons/AddMessagesvg.vue"
import Prompt from '../controls/Prompt/RequestPromt.vue';

export default {
    components:{
        MessageModal,
        AddMessage,
        Prompt
    },
    data(){
        return{
            PromptEnabled:false,
            PromptType:false,
            EnabledAdd: false,
            TableView: true,
            inbox:'',
            name:null,
            EmpFullname:'',
            DisplayName:'',
            message:'',
            to:'',
            messageData:'',
            referenceKey:'',
            modalMessage:false,
            messageLoading:false,
        }
    },
    mounted(){
        this.getAllName()
    },
    methods: {
        HideView(){
            if (!this.TableView){
                this.TableView = true
                this.EnabledAdd = false
                this.ViewTable = 'Send A Message'
            }
            else{
                this.TableView = false
                this.EnabledAdd = true
                this.ViewTable = 'View Table'
            }
        },
        async getInbox(){
    
            let state  = this.$store.state
            const success =  await Services.getInbox(state.employee_key)
            this.inbox = success.data
        },
        async getMessage(inbox){
            this.messageLoading == true

            if(inbox.from != this.$store.state.employee_key){
                this.DisplayName =  this.getName(inbox.from)
                this.to = inbox.from
            }
            else{
                this.DisplayName =  this.getName(inbox.to)
                this.to = inbox.to
            }
            this.referenceKey = inbox.reference_key
            this.messageLoading = false
            this.refreshMessage(inbox.reference_key)
        },
        async getAllName(){
            this.$emit('showLoader')
            const success =  await Services.getEmployeeName()
            this.name = success.data
            this.getInbox()

            this.$emit('hideLoader')
        },

        // getName(employee_key){
        //     this.EmpFullname = this.name.filter(name=>name.employee_key === employee_key)
        //     return this.EmpFullname[0].full_name
        // },
        
        getName(employee_key){
            const name = this.name.find(name => name.employee_key === employee_key);
            return name ? name.full_name : undefined; // Return undefined if not found
        },
        async sendMessage(){
            this.messageLoading = true

            if(this.to === '' || this.messageData ==='' ){
                return
            }

            let state  = this.$store.state
            const success =  await Services.sendMessage(state.employee_key,this.to,this.messageData)
            this.result = success.data
            this.refreshMessage(this.referenceKey)
            this.getInbox()
            this.messageLoading = false
           
        },

        async refreshMessage(reference_key){
            this.messageLoading = true
            const success =  await Services.getMessage(reference_key)
            this.message = success.data
            this.messageData = ''
            this.messageLoading = false

        },
        async createMessage(to,message){

            if(to== "" || message === ""){
                this.PromptType    = "MESSAGEVALIDATION"
                this.PromptEnabled = true
                return
            }

            this.modalMessage = false
            let state  = this.$store.state
            const success =  await Services.sendMessage(state.employee_key,to,message)
            this.result = success.data
            this.getInbox()
            
     
  
        },
        scrollToBottom: function() {
                var container = document.getElementById('messageContainer');
                container.scrollTop = container.scrollHeight;
        },
    },
    updated: function() {
            this.scrollToBottom(); // Scroll to bottom whenever component updates
        }
}
</script>


<style>
.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #797777;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 
</style>
